<template>
  <div>
    <el-dialog
    :append-to-body="true"
     title="定时运行"
    :close-on-click-modal="false"
    :before-close="closeView"
     class="addTaskView"
      :visible="currentStep === 3"
      width="550px">
      <el-form ref="ruleForm"  :rules="rules" :model="form">
        <!-- <el-row>
           <span class="star">*</span> 定时运行开关
        </el-row>
        <el-switch
            v-model="form.taskStatus">
        </el-switch> -->

          <el-row>
           <span class="star">*</span> 生效日期
          </el-row>
        <el-form-item label="" prop="date">
          <el-date-picker
          :picker-options="effectivePickerOptions"
            style="width:100%"
           :disabled="operate==='detail'"
            v-model="form.date"
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-row>
           <span class="star">*</span> 调度周期
        </el-row>
         <el-form-item label="" prop="schedulerPeriod">
          <el-select  :disabled="operate==='detail'" v-model="form.schedulerPeriod" @change="changePeriodType"  placeholder="请选择调度周期">
            <el-option
              v-for="item in peroidList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
         </el-form-item>

         <el-row>
           历史生效日期<span class="historyBtn" v-if="showHistory === false" @click="showHistory = !showHistory">展开 +</span>
           <span class="historyBtn" v-else @click="showHistory = !showHistory">隐藏 -</span>
        </el-row>
         <el-form-item label="" prop="historyDate" v-show="showHistory">
            <el-date-picker
            type="datetimerange"
            :editable="false"
            @focus="historyFocs"
            :validate-event="true"
            :picker-options="getOptionFun"
            style="width:100%"
           :disabled="operate==='detail'"
            v-model="form.historyDate"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="结束日期">
          </el-date-picker>
         </el-form-item>

      <div v-if="form.schedulerPeriod === '2'">
        <el-row>
           <span class="star">*</span> 指定时间
          </el-row>
           <el-form-item label="" prop="scheduleTime">
            <el-select
             :disabled="operate==='detail'"
              @change="selChange"
              v-model="form.scheduleTime"
              multiple
              placeholder="请选择">
              <el-option
                v-for="item in weekList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
           </el-form-item>
      </div>

      <div v-if="form.schedulerPeriod === '3'">
          <el-row>
           <span class="star">*</span> 指定时间
          </el-row>
           <el-form-item label="" prop="scheduleTime">
            <el-select
             :disabled="operate==='detail'"
               @change="selChange"
              v-model="form.scheduleTime"
              multiple placeholder="请选择">
              <el-option
                v-for="item in dayList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
           </el-form-item>
      </div>

      <div v-if="form.schedulerPeriod === '1'">
        <el-row>
           <span class="star">*</span> 具体时间
          </el-row>
          <el-form-item label="" prop="scheduleTime">
            <el-select
              style="width:100%"
             :disabled="operate==='detail'"
                @change="selChange"
                v-model="form.scheduleTime"
                multiple placeholder="请选择">
              <el-option
                v-for="item in hourList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      </div>

      <div v-if="form.schedulerPeriod === '0'">
        <el-row>
           <span class="star">*</span> 时间间隔
          </el-row>
          <el-form-item label="" prop="scheduleTime">
            <el-select
             :disabled="operate==='detail'"
                @change="selChange"
                v-model="form.scheduleTime"
                multiple placeholder="请选择">
              <el-option
                v-for="item in minuteList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      </div>
      <div v-if="form.schedulerPeriod !== '1' && form.schedulerPeriod !== '0'">
        <el-row>
           <span class="star">*</span> 具体时间
        </el-row>
        <el-form-item label="" prop="time">
          <!-- <el-time-picker
           :disabled="operate==='detail'"
            v-model="form.time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
            placeholder="请选择具体时间">
          </el-time-picker> -->

          <el-cascader
            separator=""
            :disabled="operate==='detail'"
            v-model="form.time"
            :options="timeList"
            :props="{ expandTrigger: 'hover' }">
          </el-cascader>

        </el-form-item>
      </div>

        <!-- <el-row>
           <span class="star">*</span> 统计方式
        </el-row>
         <el-form-item label="" prop="way">
          <el-select
            v-model="form.way"
            :disabled="form.schedulerPeriod.toString() === '1' || operate==='detail'"
            placeholder="请选择统计方式">
              <el-option label="按天统计" :value="1"/>
              <el-option label="按小时统计" :value="2"/>
          </el-select>
         </el-form-item> -->
      <!-- 统计时间方式 1 昨天数据 或 2 当天数据 way=1时 必传 -->
         <div v-if="form.schedulerPeriod.toString() !== '1' && form.schedulerPeriod.toString() !== '0'">
           <el-row>
              <span class="star">*</span> 统计时间方式
            </el-row>
            <el-form-item label="" prop="statisticsWay">
              <el-select  :disabled="operate==='detail'" v-model="form.statisticsWay"   placeholder="请选择统计时间方式">
                  <el-option label="昨天数据" :value="1"/>
                  <el-option label="当天数据" :value="2"/>
              </el-select>
            </el-form-item>
         </div>

      </el-form>
      <span slot="footer" class="dialog-footer">

        <el-button v-if="operate==='detail'" type="primary" @click="closeView" size="small">确 定</el-button>
        <template v-else>
          <el-button  @click="prevStep" size="small">上一步</el-button>
          <el-button  type="primary" @click="addTask" size="small">添加</el-button>
        </template>

        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addTask } from '@/api/dataStatistics'
import {
  dataFormat
// dateHelper
} from '@/utils'
import eventBus from '@/assets/js/eventBus'
export default {
  components: {
  },
  props: {
    singleVisible: {
      type: Boolean
    },
    productList: {
      type: Array || null
    },
    singleAddDetail: {
      type: Object
    },
    currentStep: {
      type: Number
    },
    taskDetail: {
      type: Object
    },
    operate: {
      type: String
    }
  },
  data: function () {
    var validateDate = (rule, value, callback) => {
      if (!this.form.date) {
        callback(new Error('请选择日期'))
      } else {
        callback()
      }
    }
    var validatePeriod = (rule, value, callback) => {
      if (this.form.schedulerPeriod === '') {
        callback(new Error('请选择调度周期'))
      } else {
        callback()
      }
    }
    var validateScheduleTime = (rule, value, callback) => {
      if (!this.form.scheduleTime.length) {
        let errorMes
        if (this.form.schedulerPeriod === '0') {
          errorMes = '请选择时间间隔'
        } else if (this.form.schedulerPeriod === '1') {
          errorMes = '请选择具体时间'
        } else {
          errorMes = '请选择指定时间'
        }
        callback(new Error(errorMes))
        // this.form.schedulerPeriod === '1' ? callback(new Error('请选择具体时间')) : callback(new Error('请选择指定时间'))
      } else {
        callback()
      }
    }
    var validateTime = (rule, value, callback) => {
      if (!this.form.time) {
        callback(new Error('请选择具体时间'))
      } else {
        callback()
      }
    }
    var validateStatisticsWay = (rule, value, callback) => {
      if (// this.form.way.toString() === '1' &&
        !this.form.statisticsWay) {
        callback(new Error('请选择统计时间方式'))
      } else {
        callback()
      }
    }

    var validateHistoryDate = (rule, value, callback) => {
      console.log('this.form.historyDate:', this.form.historyDate)
      if (this.form.historyDate.length > 0) {
        console.log(99999)
        let statisticsWay = '1'// 默认为昨天数据
        let schedulerPeriod = '2'// 默认为2
        !isNaN(this.form.statisticsWay) && this.form.statisticsWay !== '' ? statisticsWay = this.form.statisticsWay : ''
        !isNaN(this.form.schedulerPeriod) && this.form.schedulerPeriod !== '' ? schedulerPeriod = this.form.schedulerPeriod : ''
        let timeInterval
        let dayNum
        if (schedulerPeriod === '2' || schedulerPeriod === '3') {
          timeInterval = 3600 * 24 * 30 * 1000 - 1000 // 减去一秒
          dayNum = 30
        } else if (schedulerPeriod === '1') {
          // schedulerPeriod等于1 为小时统计 不能超过当天当时 历史开始时间与结束时间间隔不能超过7天
          timeInterval = 3600 * 24 * 7 * 1000 - 1000 // 减去一秒
          dayNum = 7
        } else if (schedulerPeriod === '0') {
          // schedulerPeriod等于0 为按分统计 不能超过当天当时当分 历史开始时间与结束时间间隔不能超过1天
          timeInterval = 3600 * 24 * 2 * 1000 - 1000
          dayNum = 1
        }
        // 所以干脆最精确，不管哪种情况，都不能超过此时此分此秒
        const limmitDate = new Date()
        // 昨天就要减一天时间
        const timesamp = statisticsWay.toString() === '1' ? (limmitDate.getTime() - 3600 * 24 * 1000) : limmitDate.getTime()
        if (this.form.historyDate[1].getTime() > timesamp) {
          statisticsWay.toString() === '1' ? callback(new Error('结束时间不能超过昨天')) : callback(new Error('结束时间不能超过今天'))
        } else if ((this.form.historyDate[1].getTime() - this.form.historyDate[0].getTime()) > timeInterval) {
          callback(new Error(`时间跨度不能超过${dayNum}天`))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    return {
      form: {
        schedulerPeriod: this.taskDetail.schedulerPeriod !== '' && !isNaN(this.taskDetail.schedulerPeriod) ? this.taskDetail.schedulerPeriod.toString() : '', // 调度周期 1 小时 2 周 3 月（当调度周期为小时 统计方式只能为按小时统计）
        scheduleTime: this.taskDetail.scheduleTime ? this.taskDetail.scheduleTime.split(',') : [], // 指定时间 小时（0~23） 周（1~7） 月（1~31） 单选：1 多选：0,1,2,3 全选：*
        date: this.taskDetail.beginTime ? [this.taskDetail.beginTime.split(' ')[0], this.taskDetail.endTime.split(' ')[0]] : '', // 日期
        time: this.taskDetail.hour !== '' && !isNaN(this.taskDetail.hour) ? [this.taskDetail.hour, this.taskDetail.minute] : '', // 具体时间
        taskStatus: false, // 任务状态
        // way: this.taskDetail.way ? this.taskDetail.way : 1, // 统计方式（1 按天统计 2 按小时统计）（当调度周期为小时 统计方式只能为按小时统计）
        statisticsWay: this.taskDetail.statisticsWay ? this.taskDetail.statisticsWay : '', // 统计时间方式 1 昨天数据 或 2 当天数据 way=1时 必传
        historyDate: this.taskDetail.oldBeginTime ? [this.taskDetail.oldBeginTime, this.taskDetail.oldEndTime] : '' // 历史日期
      },
      rules: {
        date: [
          { validator: validateDate, trigger: 'change' }
        ],
        schedulerPeriod: [
          { validator: validatePeriod, trigger: 'change' }
        ],
        scheduleTime: [
          { validator: validateScheduleTime, trigger: 'change' }
        ],
        time: [
          { validator: validateTime, trigger: 'change' }
        ],
        // way: [
        //   { required: true, message: '请选择统计方式', trigger: 'change' }
        // ],
        statisticsWay: [
          { validator: validateStatisticsWay, trigger: 'change' }
        ],
        historyDate: [
          { validator: validateHistoryDate, trigger: 'change' }
        ]
      },
      date: '',
      time: '',
      value: '',
      // 调度周期 1 小时 2 周 3 月（当调度周期为小时 统计方式只能为按小时统计）
      peroidList: [
        { label: '分钟', value: '0' },
        { label: '天', value: '1' },
        { label: '周', value: '2' },
        { label: '月', value: '3' }
      ],
      weekList: [
        { label: '全选', value: '*' },
        { label: '星期一', value: '1' },
        { label: '星期二', value: '2' },
        { label: '星期三', value: '3' },
        { label: '星期四', value: '4' },
        { label: '星期五', value: '5' },
        { label: '星期六', value: '6' },
        { label: '星期日', value: '7' }
      ],
      showHistory: false,
      effectivePickerOptions: {
        disabledDate (time) {
          // 生效日期限制只能从今天天开始
          const beginTime = new Date()
          beginTime.setHours(0)
          beginTime.setMinutes(0)
          beginTime.setSeconds(0)
          beginTime.setMilliseconds(0)
          return (time.getTime() - beginTime.getTime() < 0)
        },
        onPick (date) {
          console.log('选中后触发：', date)
        }
      },
      historyEffectiveDate: {
        minDate: '',
        maxDate: ''
      }
    }
  },
  computed: {
    getOptionFun () {
      let minDate, maxDate, limmitDate
      let statisticsWay = '1'// 默认为昨天数据
      let schedulerPeriod = '2'// 默认为2
      !isNaN(this.form.statisticsWay) && this.form.statisticsWay !== '' ? statisticsWay = this.form.statisticsWay : ''
      !isNaN(this.form.schedulerPeriod) && this.form.schedulerPeriod !== '' ? schedulerPeriod = this.form.schedulerPeriod : ''
      // console.log(99999)
      let historyEffectiveDate = Object.assign({}, this.historyEffectiveDate)
      // console.log('statisticsWay:', statisticsWay)
      return {
        disabledDate (time) {
          // 保留逻辑，暂时允许所有的都通过
          const flag = true
          if (flag) {
            return false
          }
          if (historyEffectiveDate.minDate) {
            minDate = new Date(historyEffectiveDate.minDate.getTime())
          }
          // console.log('historyEffectiveDate:', historyEffectiveDate)
          //  // schedulerPeriod等于2、3时 为按天统计  选择昨天数据 不能超过昨天日期 选择当天数据 不能超过今天日期 历史开始时间与结束时间间隔不能超过30天
          let timeInterval
          if (schedulerPeriod === '2' || schedulerPeriod === '3') {
            // console.log('限制一个月')
            timeInterval = 3600 * 24 * 30 * 1000 - 1000 // 减去一秒
          } else if (schedulerPeriod === '1') {
            // console.log('按天')
            // schedulerPeriod等于1 为小时统计 不能超过当天当时 历史开始时间与结束时间间隔不能超过7天
            timeInterval = 3600 * 24 * 7 * 1000 - 1000 // 减去一秒
          } else if (schedulerPeriod === '0') {
            // console.log('按分钟')
            // schedulerPeriod等于0 为按分统计 不能超过当天当时当分 历史开始时间与结束时间间隔不能超过1天
            timeInterval = 3600 * 24 * 2 * 1000 - 1000
          }
          // 所以干脆最精确，不管哪种情况，都不能超过此时此分此秒
          limmitDate = new Date()
          // 昨天就要减一天时间
          const timesamp = statisticsWay.toString() === '1' ? (limmitDate.getTime() - 3600 * 24 * 1000) : limmitDate.getTime()
          minDate ? maxDate = new Date(minDate.getTime() + timeInterval) : ''
          if (minDate && maxDate) {
            maxDate.getTime() > timesamp ? maxDate = new Date(timesamp) : ''
            return time.getTime() > maxDate.getTime() || time.getTime() < minDate.getTime()
          } else if (time.getTime() > timesamp) {
            return true
          }
        },
        onPick (date) {
          console.log('选中后触发：', date)
          historyEffectiveDate = date
        }
      }
    },
    timeList () {
      let i = 0
      const list = []
      const children = []
      while (i < 60) {
        children.push(
          { label: `${i}分`, value: i.toString() }
        )
        i++
      }
      i = 0
      while (i < 24) {
        list.push(
          { label: `${i}点`, value: i.toString(), children: children }
        )
        i++
      }
      return list
    },
    // 分钟得间隔时间
    minuteList () {
      let i = 1
      const list = []
      // list.push({ label: '全选', value: '*' })
      while (i < 2) {
        list.push(
          { label: `${i}分钟`, value: i.toString() }
        )
        i++
      }
      return list
    },
    // 整点时间
    hourList () {
      let i = 0
      const list = []
      list.push({ label: '全选', value: '*' })
      while (i < 24) {
        list.push(
          { label: `${i}点`, value: i.toString() }
        )
        i++
      }
      return list
    },
    dayList () {
      let i = 1
      const list = []
      list.push({ label: '全选', value: '*' })
      while (i < 32) {
        list.push(
          { label: `每月${i}日`, value: i.toString() }
        )
        i++
      }
      return list
    }
  },
  watch: {
    taskDetail () {
      if (this.taskDetail) { // 查看详情时候重新赋值显示
        this.initData()// 初始化详情数据
      }
    }
  },
  created () {
    eventBus.$on('resetFields', this.resetFields)
  },
  methods: {
    historyFocs () {
      // 重新将日期限制的最大最小值清空
      this.historyEffectiveDate = {
        minDate: null,
        maxDate: null
      }
    },
    initData () {
      const formData = {
        schedulerPeriod: this.taskDetail.schedulerPeriod !== '' && !isNaN(this.taskDetail.schedulerPeriod) ? this.taskDetail.schedulerPeriod.toString() : '', // 调度周期 1 小时 2 周 3 月（当调度周期为小时 统计方式只能为按小时统计）
        scheduleTime: this.taskDetail.scheduleTime ? this.taskDetail.scheduleTime.split(',') : [], // 指定时间 小时（0~23） 周（1~7） 月（1~31） 单选：1 多选：0,1,2,3 全选：*
        date: this.taskDetail.beginTime ? [this.taskDetail.beginTime.split(' ')[0], this.taskDetail.endTime.split(' ')[0]] : '', // 日期
        time: this.taskDetail.hour !== '' && !isNaN(this.taskDetail.hour) ? [this.taskDetail.hour + '', this.taskDetail.minute + ''] : '', // 具体时间
        taskStatus: false, // 任务状态
        statisticsWay: this.taskDetail.statisticsWay ? this.taskDetail.statisticsWay : '', // 统计时间方式 1 昨天数据 或 2 当天数据 way=1时 必传
        historyDate: this.taskDetail.oldBeginTime ? [this.taskDetail.oldBeginTime, this.taskDetail.oldEndTime] : '' // 历史日期
      }
      Object.assign(this.form, formData)
    },
    resetFields () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    selChange (val) {
      console.log('val:', val)
      if (val.indexOf('*') >= 0) {
        console.log('全选')
        this.form.scheduleTime = ['*']
      }
    },
    changePeriodType (value) {
      this.form.scheduleTime = []
      // if (value.toString() === '1') {
      //   this.form.way = 2
      // }
    },
    nextStep () {
      this.$emit('nextStep', -1)
    },
    closeView () {
      this.$emit('closeView')
    },
    update () {
      this.closeView()// 关闭弹窗
    },
    addTask () {
      this.$refs.ruleForm.validate((valid) => {
        console.log('valid:', valid)
        console.log('this.form:', this.form)
        if (valid) {
          // 验证通过之后，
          const params = {
            schedulerPeriod: '', // 调度周期 1 小时 2 周 3 月（当调度周期为小时 统计方式只能为按小时统计）
            scheduleTime: '', // 指定时间 小时（0~23） 周（1~7） 月（1~31） 单选：1 多选：0,1,2,3 全选：*
            beginTime: '',
            endTime: '',
            oldBeginTime: '',
            oldEndTime: '',
            taskStatus: 1, // 任务状态(1 关闭 2 开启)
            // way: '', // 统计方式（1 按天统计 2 按小时统计）
            statisticsWay: '', // 统计时间方式 1 昨天数据 或 2 当天数据 way=1时 必传
            hour: '',
            minute: ''
          }
          // 定时打开，需要将form对象的数据转化成后台需要的参数格式
          params.schedulerPeriod = this.form.schedulerPeriod
          params.scheduleTime = this.form.scheduleTime
          if (
            (params.schedulerPeriod.toString() === '1' && params.scheduleTime.length === 24) ||
              (params.schedulerPeriod.toString() === '2' && params.scheduleTime.length === 7) ||
              (params.schedulerPeriod.toString() === '1' && params.scheduleTime.length === 31)
          ) {
            params.scheduleTime = '*'
          } else {
            params.scheduleTime = params.scheduleTime.join(',')
          }
          params.beginTime = dataFormat(this.form.date[0], '-')
          params.endTime = dataFormat(this.form.date[1], '-')
          if (this.form.historyDate.length && this.form.historyDate.length > 0) {
            params.oldBeginTime = dataFormat(this.form.historyDate[0], '-')
            params.oldEndTime = dataFormat(this.form.historyDate[1], '-')
          }
          params.taskStatus = parseInt(this.form.taskStatus ? 2 : 1)
          // 调度周期 为周或者月有具体的时间
          if (params.schedulerPeriod.toString() !== '1') {
            params.hour = this.form.time[0]
            params.minute = this.form.time[1]
          }
          // params.way = this.form.way
          params.statisticsWay = this.form.statisticsWay
          // const params = {
          //   taskStatus: 1 // 任务状态(1 关闭 2 开启)
          // }
          Object.assign(this.taskDetail, params)
          console.log('this.taskDetail:', this.taskDetail)
          this.confirmAddTask()
        }
      })
    },
    // 发起请求添加统计任务
    confirmAddTask () {
      const params = Object.assign({}, this.taskDetail)
      if (params.propertyList.length > 0) {
        delete params.field
      }
      addTask({ params }).then(res => {
        res = res.data
        console.log('添加任务后返回的数据：', res)
        if (res.code === 200) {
          this.$emit('message', '任务添加成功')
          this.$emit('update')
          this.closeView()
        } else {
          this.$message.error('任务添加失败')
        }
      })
    },
    prevStep () {
      this.$emit('nextStep', 2)
    }
  }
}
</script>
<style lang="less" scope>
/deep/ .el-cascader-menu__hover-zone {
  display: none;
}
.addTaskView{
  .el-cascader{
    width: 100%;
  }
  .historyBtn{
    margin-left: 10px;
    color: #0070cc;
    cursor: pointer;
  }
  .star{
       color:#d93026;
    }
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .el-row:nth-child(even){
      margin-top: 15px;
    }
    .el-row:nth-child(odd){
      margin-top: 5px;
    }
    .el-select{
      width: 100%;
    }
    .el-icon-info{
      color: #0070cc;
      margin-right: 10px;
      font-size: 16px;
    }
    .tips{
      padding: 15px;
      display: flex;
      background-color: #e5f3ff;
      font-size: 10px;
    }
  }
</style>
